import logo from '../assets/shared/logo.svg';
import hamburger from '../assets/shared/icon-hamburger.svg';
import close from '../assets/shared/icon-close.svg';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import '../style/Navbar.css';

export default function Navbar(){
    const [toggle, setToggle] = useState(false)

    function clickNavbar(){
        setToggle(!toggle)
    }

    return (
        <>
            <nav>
                <div className='logo'>
                    <img src={logo} alt='logo' />
                    <div></div>
                </div>

                <ul className={toggle ? 'activeNavbar' : ''}>
                    <li>
                        <NavLink activeclassname={'active'} to={'/'}><span  className='nav-number'>00</span> HOME</NavLink>
                    </li>
                    <li>
                        <NavLink activeclassname={'active'}  to={'/destination'}><span className='nav-number'>01</span> DESTINATION</NavLink>
                    </li>
                    <li>
                        <NavLink activeclassname={'active'} to={'/crew'}><span className='nav-number'>02</span> CREW</NavLink>
                    </li>
                    <li>
                        <NavLink activeclassname={'active'}  to={'/technology'}><span className='nav-number'>03</span> TECHNOLOGY</NavLink>
                    </li>
                </ul>

                <div className='hamburger-icon' onClick={clickNavbar}>
                    <img src={toggle ? close : hamburger} alt="hamburger logo"></img>
                </div>
            </nav>
        </>
    )
}
